$('[data-video]').each(function() {
  var $player = $(this);

  $player.addClass('loading');
  $player.html('<div class="play"></div>');

  var id = $player.data('video');
  var playlist = $player.data('playlist') || '';
  var index = $player.data('index') || '';

  var previewURL = 'https://img.youtube.com/vi/' + id + '/sddefault.jpg';

  $player.css('background-image', `url('${previewURL}')`);

  $(this).one('click', function() {
    $(this).removeClass('loading');

    var url = `https://www.youtube.com/embed/${id}?autoplay=1&loop=false&enablejsapi=1&widgetid=1`;

    if (playlist) {
      url += `&listType=playlist&list=${playlist}`;

      if (index) {
        url += `&index=${index}`;
      }
    }

    $(this).html(`
      <iframe src="${url}" width="100%" height="100%" scrolling="no" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
    `);
  });
});
